<template>
  <v-col
    cols="3"
  >
    <v-card>
      <v-card-title>
        Prizes
      </v-card-title>
      <v-card-text>
        View available prizes!
      </v-card-text>
      <v-card-actions>
        <PrizeList
          :current-user="currentUser"
        />
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import PrizeList from '@/components/PrizeList.vue';

export default {
  name: 'Prizes',
  components: {
    PrizeList,
  },
  props: {
    currentUser: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-card__title {
    padding-bottom: 0;
  }

  .v-card__actions {
    padding: 0 1rem 1rem 1rem;
  }
</style>
